import { Component, OnInit } from '@angular/core';
import { DateService, HelperService, HTTPService } from 'app/services';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { datetimeFormat } from 'app/constants/date-time-format';
import { trim, debounce } from 'lodash';

interface ITireData {
  tsNumber: string,
  dateOfStorage: any;
  tireGroupedInfo: ITireGroupData[];
  _id: string;
};

interface ITireGroupData {
  tireBrand: string;
  tireModel: string;
  tireSize: string;
  quantity: number;
};
@Component({
  selector: 'app-tire-in-out-modal',
  templateUrl: './tire-in-out-modal.component.html',
  styleUrls: ['./tire-in-out-modal.component.scss']
})
export class TireInOutModalComponent implements OnInit {

  tireData: ITireData[] = [];
  customerName: string = '';
  vehicleName: string = '';
  motorVehicle: any = {};
  vehicleId: string = '';
  estimateId: string = '';
  customerId: string = '';
  hideAddToStorage: boolean = false;
  tireSuggestions: ITireData[] = [];
  searchQuery: string = '';
  isLoading: boolean = false;
  searchSuggestion = debounce(this._searchSuggestion, 700);

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private dateService: DateService,
    private httpService: HTTPService,
    private helperService: HelperService,
  ) { }

  ngOnInit() {
    const { tireStorageOutV2Data, customerName, vehicleName, motorVehicle, vehicleId, estimateId, customerId, hideAddToStorage } = this.dialogConfig.data || {};
    this.motorVehicle = motorVehicle;
    this.vehicleId = vehicleId;
    this.customerId = customerId;
    this.estimateId = estimateId;
    this.hideAddToStorage = hideAddToStorage;
    this.customerName = customerName || '';
    this.vehicleName = vehicleName || '';
    this.tireData = this.formatTireStorageData(tireStorageOutV2Data);
  }

  formatTireStorageData(tiresDataArr: any[]): Array<ITireData> {
    const tiresData = tiresDataArr?.filter((tireItem: any) => { return (tireItem?.vehicle && tireItem?.vehicle?.vehicleId === this.vehicleId)}) || [];
    if(tiresData?.length) {

      const tiresDataArray: ITireData[] = tiresData?.map((item: any) => {

        const tireDataObj: ITireData = {
          tsNumber: item?.externalId,
          dateOfStorage: item?.dateOfStorage ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(item?.dateOfStorage).getTime()), datetimeFormat.listD) : '',
          tireGroupedInfo: [],
          _id: item?._id
        };

        if(item?.tiresInfo?.length) {
          let groupedTireInfo: any = {};
          item?.tiresInfo?.forEach((tireInfoObj: any) => {
            let groupId = [tireInfoObj?.brand?.name || '', tireInfoObj?.model || '', tireInfoObj?.size || ''].join('-')?.replaceAll(' ', '')?.toLowerCase();
            if(!groupedTireInfo[groupId]) {
              groupedTireInfo[groupId] = {
                tireBrand: tireInfoObj?.brand?.name,
                tireModel: tireInfoObj?.model,
                tireSize: tireInfoObj?.size,
                quantity: 1
              }
            } else {
              groupedTireInfo[groupId].quantity++;
            }

          });

          if(Object.keys(groupedTireInfo)?.length) {
            tireDataObj.tireGroupedInfo = Object.values(groupedTireInfo);
          }
        }
        
        return tireDataObj;

      });
      return tiresDataArray;
    }
     return tiresData;
  }

  handleCloseModal(data: any = {}) {
    this.dynamicDialogRef.close(data);
  }

  _searchSuggestion(query: string, event?: any) {
    if(!event) {
      this.isLoading = true;
    }
    let motorQuery = '';
    if (this.motorVehicle) {
      const { CountryID, EngineID, SubModelID, BaseVehicleID, Year } = this.motorVehicle;
      motorQuery = `vehicleBaseId=${BaseVehicleID}&EN=${EngineID}&CO=${CountryID}&SM=${SubModelID}`;
    }

    this.httpService
      .getItems({
        type: 'tireStorage',
        limit: 100,
        motorQuery: motorQuery,
        search: trim(query),
        searchInMotor: true,
        appliedStatus: 'service',
        vehicleId: this.vehicleId,
        estimateId: this.estimateId,
        customerId: this.customerId,
        sortField: event && event?.field || 'externalId',
        sortOrder: event?.order || 1
      })
      .then(
        (data: any) => {
          const tireStorageData = [...data?.records, ...data?.secondarySuggestions?.records];
          this.tireData = this.formatTireStorageData(tireStorageData);
        },
        (err) => {
          
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      })
  }

  handleChange(value: string) {
    this.searchSuggestion(value);
  }

  addTireStorageToRo(selectedItem: any) {
    this.handleCloseModal({ isSuccess: true, item: selectedItem });
  }

}
